"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _decorate = require("@/api/zdyPage/decorate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 导入上传API
var _default = exports.default = {
  name: 'uploadImg',
  data: function data() {
    return {
      dialogVisible: false,
      //弹框默认隐藏
      dialogVisibles: false,
      // 放大的图片
      dialogImageUrl: '',
      // 上传的图片
      uploadShow: false //是否显示上传图片
    };
  },
  created: function created() {},
  methods: {
    /* 显示上传文件组件 */showUpload: function showUpload() {
      this.dialogVisible = true;
    },
    /* 传递图片地址 */uploadInformation: function uploadInformation() {
      this.$emit('uploadInformation', this.dialogImageUrl);
      // 隐藏上传弹框
      this.dialogVisible = false;
      this.uploadShow = false;
      this.dialogImageUrl = '';
    },
    // 关闭弹框
    handleClose: function handleClose() {
      var _this = this;
      this.$confirm('点击取消后您填写的信息将丢失，您确定取消？').then(function () {
        _this.handleRemove();
        _this.$emit('handleClose');
        // 隐藏上传文件
        _this.dialogVisible = false;
        _this.dialogImageUrl = '';
      }).catch(function () {});
    },
    // 删除图片
    handleRemove: function handleRemove() {
      this.uploadShow = false;
      this.dialogImageUrl = '';
      return true;
    },
    // 预览
    preview: function preview() {
      this.dialogVisibles = true;
    },
    // 上传成功
    onSuccess: function onSuccess(response) {
      // 根据新的API返回格式处理
      if (response.code !== 200) {
        this.$message.error(response.message || '上传图片失败');
        return;
      }

      // API返回格式为 {"code": 200, "data": {"pathKey": "/zdyPage/xxx.jpg"}}
      this.dialogImageUrl = response.data && response.data.pathKey ? response.data.pathKey : response.data;
    },
    // 上传前
    uploads: function uploads(file) {
      if (!file.type.includes('image')) {
        this.$message.error('请上传图片！');
        return false;
      }
      this.uploadShow = true;
    },
    // 上传失败
    uploadError: function uploadError() {
      this.$message.error('请重新上传');
      this.uploadShow = false;
    },
    /**
     * 自定义上传（使用xyZdyDragging/uploadPic接口）
     * http-request	覆盖action默认的上传行为，可以自定义上传的实现
     */
    upload: function upload(data) {
      var _this2 = this;
      var formData = new FormData();
      formData.append('file', data.file);
      (0, _decorate.uploadImg)(formData).then(function (res) {
        console.log('[uploadImg] 后端返回 res =', JSON.stringify(res));
        console.log('[uploadImg] res.data =', res.data, 'typeof =', (0, _typeof2.default)(res.data));
        // API返回格式 {"code": 200, "data": {"pathKey": "/zdyPage/xxx.jpg"}}
        if (res.code === 200) {
          _this2.dialogImageUrl = res.data && res.data.pathKey ? res.data.pathKey : res.data;
          console.log('[uploadImg] dialogImageUrl =', _this2.dialogImageUrl, 'typeof =', (0, _typeof2.default)(_this2.dialogImageUrl));
          _this2.$message.success('上传成功');
        } else {
          _this2.$message.error(res.message || '上传失败');
        }
      }).catch(function (error) {
        console.error('上传失败:', error);
        _this2.$message.error('上传失败');
      });
    }
  },
  computed: {
    // 提交按钮是否可以点击
    disabl: function disabl() {
      if (!this.dialogImageUrl) return true;
      return false;
    }
  }
};